import React from "react";

import useAppContext from "@hooks/useAppContext";

import Modal from "@components/Modal/Modal";

const ExitModal = ({ ...props }) => {
  const { showExitModal, exitUrl, closeExitModal } = useAppContext();

  return (
    <Modal showModal={!!showExitModal} closeModal={closeExitModal} {...props}>
      <h2 className="font-bold">You are now leaving our site</h2>
      <p>The site you're about to visit is not a part of our site.</p>
      <p>Are you sure you want to continue?</p>
      <div className="flex gap-4">
        <a
          href={exitUrl}
          onClick={closeExitModal}
          target="_blank"
          rel="noopener noreferrer"
        >
          Continue
        </a>
        <button onClick={closeExitModal}>Stay on site</button>
      </div>
    </Modal>
  );
};

export default ExitModal;
